import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Menu,
  MenuItem
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useDispatch } from 'react-redux';
import { closeDialogConfirm } from 'src/features/uiSlice';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { isAgencyCustomerOrder } from './orderUtils';

const ConfirmDialogs = ({
  anchorEl,
  handleMenuClose,
  menuOrder,
  isAdmin,
  isSale,
  isAccountant,
  isLeadMarketing,
  isAgency,
  isAdminSale,
  isAgencySale,
  dataLogin,
  handleEditOrder,
  handleCopyOrder,
  handleDeleteOrder,
  handleCancelOrder,
  confirmDelete,
  openCompleteConfirm,
  setOpenCompleteConfirm,
  confirmComplete,
  openCancelConfirm,
  setOpenCancelConfirm,
  confirmCancel,
  handleViewDetailOrder,
  handleBypassSerial,
  onOpenAddReceipt,
  openDeleteReceiptConfirm,
  setOpenDeleteReceiptConfirm,
  confirmDeleteReceipt,
  receiptToDelete,
  agencyDebtMap = {}
}) => {
  const dispatch = useDispatch();

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {menuOrder && handleViewDetailOrder && (
          <MenuItem
            onClick={() => {
              handleViewDetailOrder(menuOrder);
              handleMenuClose();
            }}
            style={{ color: '#3f51b5' }}
          >
            <VisibilityIcon fontSize="small" style={{ marginRight: 8 }} />
            Xem chi tiết phiếu
          </MenuItem>
        )}

        {menuOrder && !isAgency && !isSale && !isLeadMarketing && !isAdminSale && !isAgencySale && menuOrder.status !== -1 && onOpenAddReceipt && (
          <MenuItem
            onClick={() => {
              const isAgencyCustomer = isAgencyCustomerOrder(menuOrder);
              const pId = isAgencyCustomer
                ? menuOrder.agency_id || menuOrder.agency?.id
                : menuOrder.end_user_id || menuOrder.end_user?.id || menuOrder.customer_id;
              const pName =
                menuOrder.end_user?.full_name ||
                (!isAgencyCustomer ? (menuOrder.customer_name || menuOrder.customerName) : '') ||
                menuOrder.agency?.name ||
                menuOrder.customer_name ||
                menuOrder.customerName ||
                '';
              const pPhone =
                menuOrder.customer_phone ||
                menuOrder.phone ||
                menuOrder.phone_number ||
                menuOrder.customerPhone ||
                menuOrder.end_user?.phone ||
                menuOrder.end_user?.phone_number ||
                (isAgencyCustomer ? menuOrder.agency?.leader?.phone || menuOrder.agency?.phone : '') ||
                '';
              const pAddr =
                menuOrder.address ||
                menuOrder.customer_address ||
                menuOrder.shipping_address ||
                menuOrder.end_user?.address ||
                (isAgencyCustomer ? menuOrder.agency?.leader?.address || menuOrder.agency?.address || menuOrder.agency_name : '') ||
                '';
              const orderCode = menuOrder.code || menuOrder.order_code || menuOrder.orderCode || '';

              if (isAgencyCustomer) {
                const agKey = String(pId || '');
                const agNameKey = (pName || '').trim().toLowerCase();
                const agInfo = agencyDebtMap ? (agencyDebtMap[agKey] || agencyDebtMap[agNameKey] || null) : null;
                const debt = agInfo?.debt !== undefined ? agInfo.debt : 0;
                onOpenAddReceipt({
                  payer_type: 'AGENCY',
                  payer_id: pId,
                  payer_name: pName,
                  customer_name: pName,
                  customer_phone: pPhone,
                  phone: pPhone,
                  address: pAddr,
                  company: pAddr,
                  amount: debt > 0 ? debt : 0,
                  agency_debt: debt,
                  note: `Thu tiền công nợ Đại lý ${pName}`
                });
              } else {
                onOpenAddReceipt({
                  order_id: menuOrder.id,
                  order_code: orderCode,
                  payer_type: 'END_USER',
                  payer_id: pId,
                  payer_name: pName,
                  customer_name: pName,
                  customer_phone: pPhone,
                  phone: pPhone,
                  address: pAddr,
                  company: pAddr,
                  amount: menuOrder.total_amount || menuOrder.totalAmount || 0,
                  note: orderCode ? `Thu tiền đơn hàng #${orderCode}` : ''
                });
              }
              handleMenuClose();
            }}
            style={{ color: '#2e7d32' }}
          >
            <AddCircleIcon fontSize="small" style={{ marginRight: 8 }} />
            Tạo phiếu thu
          </MenuItem>
        )}

        {menuOrder && (() => {
          const isOwnOrder = Boolean(dataLogin?.id && (
            menuOrder.sale_id === dataLogin.id ||
            menuOrder.created_by === dataLogin.id ||
            menuOrder.sale?.id === dataLogin.id
          ));
          const isSubordinateOrder = Boolean(isLeadMarketing && dataLogin?.id && (
            menuOrder.sale?.manager_id === dataLogin.id ||
            menuOrder.manager_id === dataLogin.id
          ));
          const canModify = isAdmin || isOwnOrder || isSubordinateOrder;

          return (
            <>
              {canModify && (
                <MenuItem
                  onClick={() => {
                    handleEditOrder(menuOrder);
                    handleMenuClose();
                  }}
                  disabled={menuOrder.status >= 4}
                  style={{ color: '#2980b9' }}
                >
                  <EditIcon fontSize="small" style={{ marginRight: 8 }} />
                  Sửa phiếu
                </MenuItem>
              )}
              {(isAdmin || isSale || isLeadMarketing) && (
                <MenuItem
                  onClick={() => {
                    handleCopyOrder(menuOrder);
                    handleMenuClose();
                  }}
                  style={{ color: '#009688' }}
                >
                  <FileCopyIcon fontSize="small" style={{ marginRight: 8 }} />
                  Sao chép phiếu
                </MenuItem>
              )}
              {menuOrder.status < 3 && isAdmin && (
                <MenuItem onClick={handleDeleteOrder} style={{ color: '#d32f2f' }}>
                  <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
                  Xóa phiếu
                </MenuItem>
              )}
              {menuOrder.status !== -1 && menuOrder.status < 4 && (isAdmin || isAccountant || canModify) && (
                <MenuItem onClick={handleCancelOrder} style={{ color: '#666' }}>
                  <CloseIcon fontSize="small" style={{ marginRight: 8 }} />
                  Hủy phiếu
                </MenuItem>
              )}
            </>
          );
        })()}
      </Menu>

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_ORDER}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_ORDER}
        callbackOk={confirmDelete}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />


      <Dialog
        open={openCancelConfirm}
        onClose={() => setOpenCancelConfirm(false)}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1a1f36' }}
          >
            Xác nhận hủy đơn
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Bạn có chắc chắn muốn hủy đơn hàng này không?
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 8 }}
          >
            Sau khi hủy, các thao tác cho đơn hàng này sẽ bị khóa.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: 16 }}>
          <Button
            onClick={() => setOpenCancelConfirm(false)}
            variant="outlined"
            color="primary"
            style={{ fontWeight: 600 }}
          >
            Đóng
          </Button>
          <Button
            onClick={confirmCancel}
            variant="contained"
            color="secondary"
            style={{ fontWeight: 600 }}
          >
            Xác nhận hủy
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(openDeleteReceiptConfirm)}
        onClose={() => setOpenDeleteReceiptConfirm && setOpenDeleteReceiptConfirm(false)}
      >
        <DialogTitle disableTypography style={{ padding: '16px 24px', borderBottom: '1px solid #e0e3ef' }}>
          <Typography variant="h6" style={{ fontWeight: 700, color: '#1a1f36' }}>
            Xác nhận xóa phiếu thu
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ padding: '20px 24px' }}>
          <Typography style={{ fontSize: 14, color: '#333' }}>
            Bạn có chắc chắn muốn xóa phiếu thu <strong>#{receiptToDelete?.code || receiptToDelete?.id}</strong> không?
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            Hành động này sẽ cập nhật lại số tiền đã thanh toán của đơn hàng tương ứng.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px', borderTop: '1px solid #e0e3ef' }}>
          <Button
            onClick={() => setOpenDeleteReceiptConfirm && setOpenDeleteReceiptConfirm(false)}
            variant="outlined"
            style={{ fontWeight: 600, textTransform: 'none' }}
          >
            Hủy
          </Button>
          <Button
            onClick={confirmDeleteReceipt}
            variant="contained"
            style={{ backgroundColor: '#d32f2f', color: '#fff', fontWeight: 600, textTransform: 'none' }}
          >
            Đồng ý xóa
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmDialogs;
